export enum MarketplaceTypeEnum {
  Amaro = 1
}